export default "__VITE_ASSET__BbHQ7amJ__"